import classNames from 'classnames/bind';
import { KeyPairsActions } from 'keypairs/modules/KeyPairsModule';
import Spinner from 'mcs-toolkit/components/Loader';
import React from 'react';
import { reduxHelper } from 'utils/reduxHelper';

import { ToastNotify } from 'reactApp/components/ToastNotify/ToastNotify';
import { connectFormikContext } from 'reactComponents/Forms/ConnectFormikContext';

import { FieldSelect } from './FieldSelect';
import styles from './KeySelect.css';

const css = classNames.bind(styles);

const NEW_KEY_OPTION_VALUE = 'new';
const UPLOAD_KEY_OPTION = 'key-upload';
export const USE_ORIGINAL_KEY = 'original-key';

const boundActions = reduxHelper.bindActions({
    createKeyPair: KeyPairsActions.createKeyPair,
});

const getOptions = (
    keys,
    withoutCreateOption,
    useOriginalKey,
    allowKeyUpload,
) => {
    const customKeys = [];

    if (useOriginalKey) {
        customKeys.push({
            value: USE_ORIGINAL_KEY,
            text: 'Использовать оригинальный ключ',
            key: USE_ORIGINAL_KEY,
        });
    }

    if (allowKeyUpload) {
        customKeys.push({
            value: UPLOAD_KEY_OPTION,
            text: 'Загрузить публичный ssh-rsa ключ',
            key: UPLOAD_KEY_OPTION,
        });
    }

    if (!withoutCreateOption) {
        customKeys.push({
            value: NEW_KEY_OPTION_VALUE,
            text: 'Создать новый ключ',
            key: NEW_KEY_OPTION_VALUE,
        });
    }

    const mappedKeys = keys.map(({ name }) => ({
        value: name,
        text: name,
        key: name,
    }));

    return [...customKeys, ...mappedKeys];
};

@connectFormikContext()
class KeySelect extends React.Component {
    state = {
        isLoadingLocalKey: false,
    };

    fileInput = React.createRef();

    setValue = (val) =>
        this.props._formikContext.setFieldValue(this.props.name, val);

    uploadKey = async ({ keyName, publicKey }) => {
        try {
            this.setState({ isLoadingLocalKey: true });
            const keypair = await boundActions.createKeyPair({
                keyName,
                publicKey,
                fromFile: true,
            });
            this.setValue(keypair.name);
        } catch (error) {
            // TODO: may be use try later
            ToastNotify.error(
                'При загрузке ключа произошла ошибка! Попробуйте позже или обратитесь в службу поддержки.',
            );
        } finally {
            this.setState({ isLoadingLocalKey: false });
        }
    };

    readKeyFile = () => {
        const file = this.fileInput.current.files[0];
        if (!file) {
            return;
        }

        const keyName = file.name.replace('.pub', '');

        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (event) => {
            const publicKey = event.target.result.trim();
            this.uploadKey({ keyName, publicKey });
            this.fileInput.current.value = '';
        };
    };

    onChangeHandler = (event, data, prevValue) => {
        if (data.value === UPLOAD_KEY_OPTION) {
            this.fileInput.current.click();

            // disallow to keep 'key-upload' value in field state
            this.setValue(prevValue);
        }
    };

    render() {
        const {
            name,
            label,
            keys,
            withoutCreateOption,
            useOriginalKey,
            allowKeyUpload,
            hidden,
        } = this.props;

        const { isLoadingLocalKey } = this.state;

        return (
            !hidden && (
                <div className={allowKeyUpload && css('keySelect')}>
                    {allowKeyUpload && (
                        <input
                            ref={this.fileInput}
                            id="key-uploader"
                            type="file"
                            accept=".pub"
                            hidden
                            onChange={this.readKeyFile}
                        />
                    )}
                    <FieldSelect
                        dataTest="select-key"
                        options={getOptions(
                            keys,
                            withoutCreateOption,
                            useOriginalKey,
                            allowKeyUpload,
                        )}
                        onChange={this.onChangeHandler}
                        name={name}
                        label={label}
                        disabled={isLoadingLocalKey}
                    />
                    {allowKeyUpload && (
                        <div className={css('spinnerWrapper')}>
                            <Spinner
                                className={css('spinner')}
                                active={isLoadingLocalKey}
                                size="mini"
                            />
                        </div>
                    )}
                </div>
            )
        );
    }
}

KeySelect.getDefaultKeyValue = (keys) =>
    keys.length ? keys[0].name : NEW_KEY_OPTION_VALUE;

export { KeySelect };
